import React from "react";

import { Page404 as Page404Styled, Heading, Text, ReplayButton } from "./style";
import routes from "../../routes";

export default function Home(_ref) {
  var children = _ref.children;

  return React.createElement(
    Page404Styled,
    null,
    React.createElement(
      Heading,
      null,
      "Page non trouv\xE9e !"
    ),
    React.createElement(
      Text,
      null,
      "Vous vous \xEAtes certainement perdu(e) en voulant tester vos connaissances..."
    ),
    React.createElement(
      ReplayButton,
      { to: routes.home.path },
      "Revenir"
    )
  );
}
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /Users/nicolasraynaud/Projets/jeux-mobiles-manitoba/packages/common-react/lib/pages/Page404/index.js
// module id = 466
// module chunks = 0